import type { ResourceCategoryKey } from '@/features/virtual-resource/constants'
import type DataFileMap from '@/model/Resource/DataFileMap'
import { buildDefaultVirtualResourceRoot } from '@/features/virtual-resource/rules'

/**
 * 新建工程时的默认虚拟资源树（与 docs/ue/新建.md 一致）。
 * 各分类会按资源管理器规则初始化固定顶级目录。
 */
export function buildDefaultVirtualResourceRoots(): Record<ResourceCategoryKey, DataFileMap | null> {
  return {
    graphic: buildDefaultVirtualResourceRoot('graphic'),
    audio: buildDefaultVirtualResourceRoot('audio'),
    font: buildDefaultVirtualResourceRoot('font'),
    video: buildDefaultVirtualResourceRoot('video'),
  }
}
